// Shared public-site UI theme. A brand's uploaded photographs, logos and
// documents retain their original colors; only the surrounding interface is
// monochromatic, independent of stored brand palette preferences.
export const PUBLIC_PALETTE = Object.freeze({
  "--brand": "#000000",
  "--brand-soft": "rgba(0, 0, 0, 0.16)",
  "--surface": "#FFFFFF",
  "--on-surface": "#000000",
  "--on-surface-muted": "#525252",
  "--picto-invert": 0,
  background: "#FFFFFF",
  color: "#000000",
});